<template>
  <div style="margin:50px 0;height:100%">
      <a-radio-group v-model="current" button-style="solid" size="small">
        <a-radio-button :value="0">表格</a-radio-button>
        <a-radio-button :value="1">图表</a-radio-button>
      </a-radio-group>
      <analyse-table :result="res" v-if="current == 0" />
      <analyse-chart :result="res" v-if="current == 1" />
  </div>
</template>

<script>
import AnalyseChart from './AnalyseChart.vue'
import AnalyseTable from './AnalyseTable.vue'

export default {
  components: { AnalyseTable, AnalyseChart },
  props:['res'],
  data(){
    return {
      current: 0,
    }
  },
 
  mounted(){

  },
}
</script>

<style>

</style>